import cx from 'classnames';
import styles from './Banner.module.scss';
import { BigButton, Image } from '../../common';
import { BANNER_TYPE } from '../../constants/constants';

function Banner({
  title,
  url = null,
  description,
  buttonText = '',
  containerClassName = '',
  buttonClick = null,
  type = BANNER_TYPE.IMAGE,
  variant = 'grey', // light, grey, dark
}) {
  
  if (type === BANNER_TYPE.TEXT) {
    return (
      <div className={cx(styles.containerV2, 'py-5', containerClassName)}>
        <div className={styles.innnerContainer}>
          <h2 className={styles.title}>{title}</h2>
        </div>
      </div>
    );
  }

  return (
    <div
      className={cx(
        styles.container,
        containerClassName,
        styles?.[variant] ? styles?.[variant] : ''
      )}>
      <div className={styles.info}>
        <h2>{title}</h2>
        <p>{description}</p>
        {buttonClick && (
          <BigButton
            className="bigButton lf-btn-1 btn-v2"
            buttonTitle={buttonText}
            onClick={buttonClick}
            style={{
              backgroundColor: 'var(--dark-100) !important',
            }}
          />
        )}
      </div>
      <div className={styles.banner}>
        {type === BANNER_TYPE.IMAGE ? (
          <Image src={url} className={`img-fluid ${styles.image}`} alt="" rounded={false} />
        ) : null}

        {type === BANNER_TYPE.VIDEO ? (
          <video
            className={styles.video}
            loop
            muted
            autoPlay
            playsInline
            controlsList="nodownload"
            onContextMenu={(e) => {
              e.preventDefault();
              return false;
            }}>
            <source src={url} type="video/mp4" />
          </video>
        ) : null}
      </div>
    </div>
  );
}

export default Banner;
